import React from 'react'

type TextOptionModalResumeProps = {
    title: string
    text: string
}

const TextOptionModalResume = ({ title, text }: TextOptionModalResumeProps) => {
    return (
        <div className="flex flex-d-column flex-ai-center ml-10">
            <p className="fs-12">{title}</p>
            <p className="fs-12 fw-700 mt-8">{text}</p>
        </div>
    )
}

export default React.memo( TextOptionModalResume )